import "bezier-easing";
import { logger } from "../../util/logger.mjs";
import "js-cookie";
import { getMoreExpertAdviceImg } from "../../util/contentstackHelpers.mjs";
const belowTheFoldGetters = {
  /* props used in BelowTheFold */
  belowTheFoldProps(state, getters) {
    return {
      accordionStatus: state.accordionStatus,
      bikeDiagram: getters.bikeDiagram,
      expertAdvice: getters.getExpertAdvice,
      description: state.product.description,
      featuredSpecs: state.product.featuredSpecs,
      isBike: getters.isBike,
      isJustForMembers: getters.computedIsMemberOnly,
      memberBenefitsList: getters.memberBenefitsList,
      primaryRecs: state.richRelevance.placements.primaryRecs,
      productFeatureProps: getters.productFeatureProps,
      // productReviewsProps: getters.productReviewProps,
      recsComponent: state.richRelevance.component,
      relatedLinks: state.product.relatedLinks,
      relatedRecs: state.richRelevance.placements.relatedRecs,
      reviewSummary: getters.computedReviewSummary,
      showProductStorytelling: getters.showProductStorytelling,
      showBuyingAdvice: getters.showBuyingAdvice,
      showNativeReviews: getters.showNativeReviews,
      sizeChart: getters.computedSizeChart,
      storytellingProps: getters.storytellingProps,
      styleId: state.product.styleId,
      techSpecs: state.product.techSpecs,
      userManuals: state.product.userManuals,
      videoLinkName: "details video play",
      locationImages: getters.computedLocationImages,
      showSleepingBagSizeChart: getters.showSleepingBagSizeChart,
      membershipBillboardProps: getters.membershipBillboardProps,
      curatedOutfit: getters.curatedOutfit,
      showExpertiseTestVariant1: getters.showScsVariant1,
      // PDX-5603 - Expertise Chat Variant 1
      showExpertiseTestVariant2: getters.showScsVariant2,
      // PDX-5603 - Expertise Chat Variant 1
      isInGladlyTest: getters.isInGladlyTest,
      showXlBreakpoint: getters.appPropsMap.launchToggles.enableXlBreakpoint,
      showQASection: getters.enableQASection,
      // PDX-5643 - hide qa section
      isInQATest: getters.isInQATest,
      // PDX-5643 - hide qa section
      showCoopBrandAsset: getters.showCoopBrandAsset,
      coopBrandAssets: getters.getCoopBrandAssets,
      lifestyleImagesVariant: getters.showLocationImagesExperience,
      // TO-DO: cleanup PDX-5768
      ugcImages: getters.getUGCImages,
      // TO-DO: cleanup PDX-5768
      ugcExperience: getters.getUgcImageExperience
      // TO-DO: cleanup PDX-5768
    };
  },
  /**
   * getters.computedBrandCategory
   *
   * @param {Object} state.product.primaryCategory: product primary category
   * @param {Object} state.product.brand: product brand data
   * @return {Object}: brand & primary category link data
   */
  computedBrandCategory(state) {
    const bName = state.product.brand.name;
    const pCat = state.product.primaryCategory.name;
    const bLink = state.product.brand.link;
    const pCatLink = state.product.primaryCategory.link.replace("/rei-garage", "");
    if (!bName || !bLink || !pCat || !pCatLink) return null;
    const name = bName !== pCat ? `${bName} ${pCat}` : `${bName}`;
    const link = bLink !== pCatLink ? `${bLink}${pCatLink}` : `${bLink}`;
    return {
      name,
      link
    };
  },
  /**
   * getters.memberBenefitsList
   * computed data for the membership benefits section
   * @param {*} state
   * @param {*} getters
   * @returns content for the membership benefits section
   * - created via CMS and formatted by the product-site controller
   */
  memberBenefitsList(state, getters) {
    const {
      isMember
    } = getters.unifiedCustomerData;
    const {
      membershipV2: membership
    } = state.product;
    let content = {
      renderSection: false
    };
    if (membership === null || membership === void 0) return content;
    try {
      content = {
        buttons: {
          addMembership: membership.content.actions.buyMembership,
          exploreMembership: membership.content.actions.exploreMembership
        },
        isMember,
        loading: state.cartLoadMembershipState,
        membershipAdded: getters.hasMembershipInCart,
        sections: membership.benefits,
        subheading: membership.content.benefitsHeading,
        renderSection: getters.appPropsMap.launchToggles.showMembershipSection
      };
    } catch (error) {
      content.renderSection = false;
      if (getters.computedIsMemberOnly) logger.warn("CMS Error - membership section content error");
      logger.error(error);
    }
    return content;
  },
  computedLocationImages(state, getters) {
    var _a, _b, _c;
    const enableComputedImages = (_b = (_a = getters.appPropsMap) == null ? void 0 : _a.launchToggles) == null ? void 0 : _b.enableComputedImages;
    const images = enableComputedImages ? (_c = state.product) == null ? void 0 : _c.computedImages : getters.computedImages;
    const locationImages = images == null ? void 0 : images.filter((img) => (img == null ? void 0 : img.type) === "Location Image");
    const uniqueEntries = Array.from(new Map(locationImages.map((img) => [img.uri, img])).values());
    return uniqueEntries.map((image) => ({
      altText: `Location Image for ${state.product.title}`,
      uri: image.maxWidth > image.maxHeight ? `${image.baseUri}?size=1075` : image.uri,
      thumbnailUri: `${image.baseUri}?size=120x120`,
      maxWidth: image.maxWidth,
      maxHeight: image.maxHeight
    }));
  },
  buyingAdvice(state) {
    const category = state.product.primaryCategory.canonical;
    const adviceCategory = state.buyingAdvice[category];
    return adviceCategory || void 0;
  },
  storytellingProps(state) {
    const currentStyleId = state.product.styleId;
    const {
      products
    } = state.storytelling || {};
    return products == null ? void 0 : products.find((product) => product.styleId === currentStyleId);
  },
  showBuyingAdvice(state, getters) {
    return state.product.showExpertAdviceContent && !!getters.getExpertAdvice && getters.appPropsMap.triageToggles.showBuyingAdvice;
  },
  showProductStorytelling(state, getters) {
    return getters.appPropsMap.triageToggles.showStorytelling && !!getters.storytellingProps;
  },
  productFeatureProps(state, getters) {
    return {
      productLine: {
        url: state.product.productLineUrl,
        label: state.product.productLineUrlLabel
      },
      brandCategory: getters.computedBrandCategory,
      features: state.product.features,
      origin: state.product.originCountry,
      prop65: state.messages.prop65,
      sellingCopy: getters.appPropsMap.triageToggles.sellingCopy && state.product.sellingCopy
    };
  },
  /**
    * getters.membershipBillboardProps
    * computed data for the "just far enough" membership acquisition & retention billboards
    * @param {*} state
    * @param {*} getters
    * @returns {Object} dynamic content to render product-specific values,
    *   and a membership ATC button synced to current page state
    */
  membershipBillboardProps(state, getters) {
    if (getters.isPup) return {};
    const {
      showAddToCartInterstitial
    } = state;
    const {
      membershipAcquisitionBillboardProps,
      membershipRetentionBillboardProps,
      showAcquisitionBillboard,
      showRetentionBillboard,
      unifiedCustomerData
    } = getters;
    const {
      isMember
    } = unifiedCustomerData;
    const activeBillboard = isMember ? "retention" : "acquisition";
    const showAnyBillboard = !getters.hideRewardsPlacements && !!(showAcquisitionBillboard || showRetentionBillboard);
    return {
      acquisitionBillboardProps: membershipAcquisitionBillboardProps,
      activeBillboard,
      isInterstitial: showAddToCartInterstitial,
      retentionBillboardProps: membershipRetentionBillboardProps,
      showAnyBillboard
    };
  },
  membershipAcquisitionBillboardProps(state, getters) {
    var _a;
    const isLoading = state.cartLoadMembershipState;
    const isInterstitial = state.showAddToCartInterstitial;
    const isMembershipAdded = state.membershipAddedToCart || getters.hasMembershipInCart;
    const {
      isRewards5to30Item,
      appPropsMap
    } = getters;
    const bonusCardDuration = ((_a = appPropsMap == null ? void 0 : appPropsMap.textStrings) == null ? void 0 : _a.bonusCardDuration) || "60";
    const model = {
      buttonText: "Add a one-time membership — $30",
      heading: `This ${isRewards5to30Item ? "purchase" : "item"} pays for membership!`,
      subheading: "Start earning when you buy a $30 lifetime membership.",
      rewardMath: {
        heading: "10% Reward",
        subheading: "on this and every eligible full-price item*"
      },
      bonusCardMath: {
        heading: "Bonus Card",
        subheading: `valid for ${bonusCardDuration} days after joining*`
      }
    };
    if (isLoading) {
      model.buttonText = "Adding to cart";
    } else if (isMembershipAdded) {
      model.buttonText = "Membership added to cart";
    }
    return {
      bonusCardValue: getters.computedEstimatedReward.bonusCardValue,
      imageTileAlt: getters.computedMediaCenterImages[0].altText,
      imageTileSrc: getters.computedMediaCenterImages[0].baseUri,
      isInterstitial,
      isLoading: state.cartLoadMembershipState,
      isMembershipAdded,
      productEstimatedReward: getters.computedEstimatedReward.productEstimatedReward,
      totalEstimatedReward: getters.computedEstimatedReward.totalEstimatedReward,
      ...model
    };
  },
  /**
    * getters.membershipRetentionBillboardProps
    * @param {*} state
    * @param {*} getters
    * @returns {Object} dynamic content to render retention-specific billboard
    */
  membershipRetentionBillboardProps(state, getters) {
    const {
      showAddToCartInterstitial,
      product
    } = state;
    const estimatedSavings = product.displayOptions.dividendEstimatedSavingsText;
    const heading = showAddToCartInterstitial ? "You get <span>1 year</span> for <br/>returns<sup>*</sup>" : `Get an estimated <span>${estimatedSavings}</span> (10%) in rewards<sup>*</sup> when you buy this item`;
    return {
      heading,
      isInterstitial: showAddToCartInterstitial,
      imageTileAlt: getters.computedMediaCenterImages[0].altText,
      imageTileSrc: getters.computedMediaCenterImages[0].baseUri
    };
  },
  curatedOutfit(state, getters) {
    var _a;
    const {
      product
    } = state;
    const {
      isPup
    } = product.displayOptions.pupInfo;
    const defaultCuratedOutfitProduct = {
      styleId: product.styleId,
      name: product.title,
      link: product.canonicalUrl,
      type: "SHOP_THE_LOOK",
      brand: product.brand,
      sellable: !isPup,
      reviewSummary: product.reviewSummary,
      stylePrice: product.stylePrice,
      primaryCategory: product.primaryCategory,
      badges: product.badges
    };
    if (isPup || !getters.showShopTheLook) {
      return {
        styles: [],
        data: {
          headingTop: "",
          headingBottom: "",
          authors: []
        }
      };
    }
    const {
      sellableCuratedOutfitProducts
    } = getters;
    const numOfSellable = 1 + sellableCuratedOutfitProducts.length;
    const styles = numOfSellable >= 3 ? [...sellableCuratedOutfitProducts.slice(0, 3), defaultCuratedOutfitProduct] : [];
    return {
      styles,
      // to select and pass in category author data here if added in the future
      data: (_a = state.curatedOutfitData) == null ? void 0 : _a.default
    };
  },
  sellableCuratedOutfitProducts(state) {
    const {
      curatedOutfitProducts
    } = state.product.curatedOutfit;
    return curatedOutfitProducts.filter((item) => item.sellable);
  },
  showNativeReviews(state, getters) {
    var _a, _b;
    return ((_b = (_a = getters.appPropsMap) == null ? void 0 : _a.launchToggles) == null ? void 0 : _b.enablePinia) && getters.showReviewsVariant;
  },
  getExpertAdvice(state, getters) {
    var _a, _b, _c;
    if (!state.product.expertAdvice) return null;
    const {
      mainContent,
      moreContent
    } = state.product.expertAdvice;
    if ((mainContent == null ? void 0 : mainContent.faqs) === null && !((_a = getters.appPropsMap.launchToggles) == null ? void 0 : _a.incompleteExpertAdviceTestToggle)) return null;
    return {
      mainContent: {
        imageSrc: getMoreExpertAdviceImg(mainContent == null ? void 0 : mainContent.featuredImage),
        imageAltText: (_b = mainContent == null ? void 0 : mainContent.featuredImage) == null ? void 0 : _b.altText,
        title: mainContent == null ? void 0 : mainContent.title,
        location: mainContent == null ? void 0 : mainContent.location,
        moreInfo: mainContent == null ? void 0 : mainContent.moreInfo,
        faqs: mainContent == null ? void 0 : mainContent.faqs
      },
      moreContent: moreContent == null ? void 0 : moreContent.map((entry) => ({
        imageSrc: getMoreExpertAdviceImg(entry == null ? void 0 : entry.featuredImage),
        imageAltText: entry == null ? void 0 : entry.featuredImage.altText,
        link: entry == null ? void 0 : entry.link,
        readTime: entry == null ? void 0 : entry.readTime,
        time: entry == null ? void 0 : entry.time,
        title: entry == null ? void 0 : entry.title
      })),
      styleId: state.product.styleId,
      showXlBreakpoint: (_c = getters.appPropsMap.launchToggles) == null ? void 0 : _c.enableXlBreakpoint
    };
  },
  showCoopBrandAsset(state) {
    const {
      name
    } = state.product.brand;
    const selectedBrands = ["rei co-op", "co-op cycles"];
    return selectedBrands.some((brand) => {
      var _a;
      return brand === ((_a = name == null ? void 0 : name.trim) == null ? void 0 : _a.call(name).toLowerCase());
    });
  },
  getCoopBrandAssets(state, getters) {
    if (!getters.showCoopBrandAsset) return {};
    const {
      coopBrandGifUpper,
      coopBrandGifLower,
      coopBrandStaticUpper,
      coopBrandStaticLower
    } = getters.appPropsMap.assets;
    return {
      gif: {
        upper: coopBrandGifUpper ?? "",
        lower: coopBrandGifLower ?? ""
      },
      static: {
        upper: coopBrandStaticUpper ?? "",
        lower: coopBrandStaticLower ?? ""
      }
    };
  },
  // TO-DO: cleanup PDX-5768
  getUGCImages(state, getters) {
    var _a, _b;
    return ((_b = (_a = getters.ugcImages) == null ? void 0 : _a.slice) == null ? void 0 : _b.call(_a, 0, 4)) || [];
  }
};
export {
  belowTheFoldGetters as default
};
//# sourceMappingURL=belowTheFoldGetters.mjs.map
